import { QueryClient } from '@tanstack/react-query'
import { isApiError } from '@/shared/api/problem'

/** 4xx는 다시 보내도 결과가 같으므로 재시도하지 않는다. 5xx와 네트워크 오류만 한 번 더 시도한다. */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (isApiError(error) && error.isClientError) return false
          return failureCount < 1
        },
      },
      mutations: {
        retry: false,
      },
    },
  })
}
